// Widget-Plugin: Subdashboard
vcDashboardRegistry.register("subdashboard", {
    defaults: { w: 6, h: 6, resizable: true, copyable: false, showSettings: true, pushOthers: false, category: "layer", get menuLabel() { return vcDashboardResources.get("menuLayer"); }, menuOrder: 5 },
    render: function ($container, item) {
        var name = item.name || item.title || vcDashboardResources.get("subdashboard");
        $container.html(
            "<div class='dashboard-sub-wrapper'>" +
                "<i class='fa-solid fa-table-cells dashboard-sub-icon'></i>" +
                "<span class='dashboard-sub-label'>" + name + "</span>" +
            "</div>"
        );
    },
    init: function ($item, settings) {
        var subId = settings.subId || $item.attr("data-id");
        $item.on("dblclick", function (e) {
            e.stopPropagation();
            var $el = $item.closest(".vc-dashboard-wrapper").parent();
            var api = $el.data("vcDashboard");
            if (api && api.navigateTo) {
                api.navigateTo(subId, $item.attr("data-name") || $item.attr("title") || vcDashboardResources.get("subdashboard"));
            }
        });
        $item.css("cursor", "pointer");

        if (this.defaults.showSettings) {
            vcDashboardPopup.addSettingsButton($item, function () {
                var currentName = $item.attr("data-name") || "";

                vcDashboardPopup.open({
                    title: vcDashboardResources.get("subdashboardSettings"),
                    settings: { Name: currentName },
                    fields: [
                        { key: "Name", label: vcDashboardResources.get("name"), type: "text" }
                    ],
                    onSave: function (newSettings) {
                        var name = (newSettings.Name || "").toString().trim();
                        if (name !== "") {
                            $item.attr("data-name", name);
                            $item.find(".dashboard-sub-label").text(name);
                            var itemTitle = ($item.attr("title") || "").replace(/^[^�]*/, "").replace(/^\s*�\s*/, "");
                            $item.attr("title", name + (itemTitle ? " � " + itemTitle : ""));
                            var api = vcDashboardPopup.getApi($item);
                            if (api && api.saveConfig) api.saveConfig();
                        }
                    }
                });
            });
        }
    }
});